module.exports = __webpack_public_path__ + "img/wallpaper-3.1a8f44ba.png";